import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

const hexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Must be a hex color');

export const expenseCategorySchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  color: hexColor,
  sortOrder: z.number().int(),
  isDefault: z.boolean(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

export const expenseCategoryInputSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100),
  color: hexColor,
  sortOrder: z.number().int().optional(),
});

export const expenseCategoryUpdateSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  color: hexColor.optional(),
  sortOrder: z.number().int().optional(),
});

export type ExpenseCategoryInput = z.infer<typeof expenseCategoryInputSchema>;
export type ExpenseCategoryUpdate = z.infer<typeof expenseCategoryUpdateSchema>;
